export default __webpack_public_path__ + "static/media/popAd8.99bd32fb.gif";